import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Componente para proteger rutas y redirigir si no se cumplen requisitos
const ProtectedRoute = ({ children, canAccess, redirectTo = '/' }) => {
  const location = useLocation();
  
  if (!canAccess) {
    console.warn('=== PROTECTED ROUTE - ACCESS DENIED ===');
    console.warn('Trying to access:', location.pathname);
    console.warn('Redirecting to:', redirectTo);
    console.warn('canAccess:', canAccess);
    
    // Verificar progreso en localStorage
    const progress = JSON.parse(localStorage.getItem('greenscape_progress') || '{}');
    console.warn('Current progress:', progress);
    
    return <Navigate to={redirectTo} replace />;
  }

  console.log('✓ Protected route access granted:', location.pathname);
  return children;
};

export default ProtectedRoute;


